const moduleListItem = {
  bindings: {
    module: '<',
    active: '<',
    onSelect: '&'
  },
  templateUrl:
    '/modules/configurationManagement/train-management/module-list/module-list-item/module-list-item.html',
  controller: 'ModuleListItemController',
};

angular
  .module('configuration-management.module')
  .component('moduleListItem', moduleListItem);
